import { createAction, props } from "@ngrx/store";
import { SaveUserInfo } from "src/app/core/models/entites/userInfo";
import { UserActionTypes } from "./action-types";

export const SAVE_USER_INFO = createAction(UserActionTypes.SaveUserInfo, props<{ modifiedUser: SaveUserInfo }>());
export const SAVE_USER_INFO_SUCCESS = createAction(UserActionTypes.SaveUserInfoSuccess, props<{ modifiedUser: SaveUserInfo }>());
export const SAVE_USER_INFO_FAILED = createAction(UserActionTypes.SaveUserInfoFailed, props<{ message: string }>());
export const UPDATE_POINTS_COUNT = createAction(UserActionTypes.UpdatePointsCount, props<{ pointsCount: number }>());

export const HIDE_EXPIRING_MBC_NOTIFIACTION = createAction(UserActionTypes.HideExpiringMbcNotification, props<{ clientId: string }>());
export const HIDE_EXPIRING_MBC_NOTIFIACTION_SUCCESS = createAction(UserActionTypes.HideExpiringMbcNotificationSuccess);
export const HIDE_EXPIRING_MBC_NOTIFIACTION_FAILED = createAction(UserActionTypes.HideExpiringMbcNotificationFailed);